import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" style={{ marginTop: '30px' }}>
      © 2026 StockFlow. Все права защищены.
    </footer>
  );
};

export default Footer;
